export const setLocalStorage = (name, value) => {
    localStorage.setItem("product-management-system:" + name, JSON.stringify(value))
}
export const getLocalStorage = (name) => {
    return JSON.parse(localStorage.getItem("product-management-system:" + name))
}

export const deleteLocalStorage = (name) => {
    localStorage.removeItem("product-management-system:" + name)
}

export const clearLocalStorage = () => {
    localStorage.clear()
}